import { useQuery } from "@tanstack/react-query";
import { ApiBalance } from "@/shared/api/balance/api-balance";
import { type Balance } from "@/shared/api/types";

const apiBalance = new ApiBalance();

export function useBalance(sellerId: string | null) {
  const queryKey = ["balance", sellerId];

  const queryFn = async (): Promise<Balance> => {
    if (!sellerId) {
      throw new Error("Seller ID is required to fetch balance.");
    }
    const response = await apiBalance.getBalance(sellerId);
    return response.data;
  };

  const { data, isLoading, error, isError, refetch } = useQuery<Balance, Error>(
    {
      queryKey,
      queryFn,
      enabled: !!sellerId,
      staleTime: 1000 * 30 * 1,
      retry: 2,
    },
  );

  return {
    balance: data,
    isLoading,
    error: error?.message || null,
    isError,
    retryFetch: refetch,
  };
}
